import React, { useEffect } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonRow, IonCol, IonLabel, IonInput, IonItem, IonTextarea, IonSelect, IonSelectOption, IonItemDivider, IonIcon, useIonViewWillEnter, IonButton, IonList, IonButtons, IonBackButton, IonToggle } from '@ionic/react'
import db from '../../resources/db';
import sendWhatsApp from '../../resources/WhatsApp';
import { alertController, toastController } from '@ionic/core';
import AddProduct from './AddProduct';
import { useLocalStorage } from '../../resources/Hooks';
import { trash } from 'ionicons/icons';
import { useCreateInvoice } from '../../contexts/useCreateInvoice';
var moment = require('moment');

const CreateInvoice = () => {

    useIonViewWillEnter(async () => {
        // this will attach the already present customer while auto-completing the customer name
        let nameplace = await document.getElementById('customerName').getInputElement()
        nameplace.setAttribute('list', 'customerList')
    })

    const { aggregateTotals,
        Products, addProduct, removeProduct,
        CustomerList,
        Config, setConfig, Company,
        CustomerName, setCustomerName,
        CustomerContact, setCustomerContact,
        CustomerDetails, setCustomerDetails,
        CustomerGST, setCustomerGST,
        AmtPaid, setAmtPaid,
        saletype, setSaletype,
        date, setDate,
        invoiceManual, setInvoiceManual,
        printBill, clearAll } = useCreateInvoice();


    const [invoiceNo, setinvoiceNo] = useLocalStorage('invoiceno', Company.lastInvNo || 1);
    const [gstinvoiceNo, setgstinvoiceNo] = useLocalStorage('gstinvoiceno', Company.lastGstInvNo || 1);
    const gstPattern = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;

    const { subTotal, gstTotal, total } = aggregateTotals();



    /**Generate Bill , creates invoices and add data to ledger */
    const generateBill = async () => {

        let billDate = moment(date).format('ll');

        /** Invoice Json */
        const invoice = {
            id: Date.now(),
            gstEnabled: Config.gst.enabled,
            invoiceNo: Config.gst.enabled ? "G-" + gstinvoiceNo : invoiceNo,
            billDate,
            customerName: CustomerName.length ? CustomerName.trim() : "######",
            customerGST: CustomerGST ? CustomerGST.trim().toUpperCase() : "",
            customerDetails: CustomerDetails ? CustomerDetails.trim() : "",
            customerContact: CustomerContact ? CustomerContact.trim() : '',
            companyName: Company.name,
            companyAddress: Company.address,
            companyContact: Company.contact,
            gst: Company.gst,
            products: Products,
            saletype: saletype,
            subtotalAmt: subTotal,
            gstTotal: gstTotal,
            totalAmt: total,
        }
        // console.log(invoice);

        const ledger = {
            billId: invoice.id,
            billNo: invoice.invoiceNo,
            customerName: CustomerName.length ? CustomerName.trim() : "######",
            customerGST: CustomerGST ? CustomerGST.trim().toUpperCase() : "",
            customerDetails: CustomerDetails ? CustomerDetails.trim() : "",
            customerContact: CustomerContact ? CustomerContact.trim() : '',
            date: billDate,
            debit: parseFloat(total),
            credit: parseFloat(AmtPaid ? AmtPaid : 0),
            receivable: parseFloat(total) - parseFloat(AmtPaid ? AmtPaid : 0),
            payable: 0,
            isCustomer: 1, //true
        }
        ledger.cash = ledger.credit

        // check for GsT Pattern or return no bill if error 

        if ((!gstPattern.test(invoice.customerGST)) && (invoice.customerGST !== "")) {
            toastController.create({
                color: 'danger',
                duration: 2000,
                message: "GST No. is Wrong. Fill the Correct one to Generate Bill.",
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });

            return;
        }

        // add to db
        if (invoice.products.length) {

            db.db.transaction('rw', db.invoices, db.ledger, db.stocks, async () => {
                await db.invoices.put(invoice).then((res) => {
                    console.log('Bill Generated', res);
                })
                await db.ledger.put(ledger).then((res) => {
                    console.log('Ledger Generated', res);
                })

                invoice.products.forEach(async (item) => {
                    let logentry = {
                        id: `stk_${Date.now()}`,
                        to: ledger.customerName,
                        billNo: invoice.invoiceNo,
                        billId: ledger.billId,
                        date: billDate,
                        type: "Sales",
                        quantity: item.quantity,
                        rate: item.price,
                        amount: item.amount,
                    };

                    await db.stocks.where("productName").equals(item.name).modify((value, ref) => {
                        console.log(value, ref);
                        // ref.value.log = []
                        value.log.push(logentry);
                    }).then(async (res) => {
                        console.log('updated stocks', res);

                        // if stock doesnt exist then create one
                        if (!res && item.name) {
                            let stockdata = {
                                productName: item.name,
                                quantity: parseFloat(item.quantity) * -1,
                                rate: parseFloat(item.price),
                                purchaseRate: 0,
                                gstRate: parseFloat(item.gstr ? item.gstr : 0),
                                hsn: '',
                                log: [],
                            };
                            await db.stocks.put(stockdata).then((res) => {
                                console.log('Product Item added.', res);
                                db.stocks.where("productName").equals(item.name).modify((value, ref) => {
                                    console.log(value, ref);
                                    // ref.value.log = []
                                    value.log.push(logentry);
                                })
                            });
                        }
                    });
                })
            }).then(() => {
                if (Config.gst.enabled) {
                    setgstinvoiceNo(gstinvoiceNo + 1);
                } else {
                    setinvoiceNo(invoiceNo + 1);
                }

                db.companies.update(1, {
                    lastInvNo: invoiceNo,
                    lastGstInvNo: gstinvoiceNo,
                }).then((res) => {
                    console.log('Company Updated', res);
                })

                printBill(invoice)
                clearAll();
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }).catch(function (err) { console.error(err) });

        } else {

            toastController.create({
                color: 'danger',
                duration: 2000,
                message: "ERROR GENERATING BILL",
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });
        }

        //whatsapp integration
        if (Config.whatsapp) {

            let bill = `Welcome to ${invoice.companyName} \n \n ` +
                invoice.products.forEach((item, i) => i + ` \t ` + item.name + ` \t ` + item.quantity + ` \t ` + item.price + ` \t RS.` + item.amount + `\n`) +
                `\n Total : ${subTotal}  \n`;
            let body = `Dear Customer ${CustomerName},your bill has been generated of Rs. ${subTotal}. \n Amount Paid : Rs. ${AmtPaid} .\n Pay remaining amount within 10 days of purchase.\n Ignore if already payed.\n Thanks for shopping. \n ${Company.name} `;
            CustomerContact.length && sendWhatsApp(CustomerContact, body);
        }

    }

    const ProductTable = (
        <IonList className='product-table' >
            <IonItem color='medium'>
                <IonCol style={{ textAlign: "center" }}>S.No.</IonCol>
                <IonCol className='ion-padding-horizontal' style={{ textAlign: "center" }}>Product Name </IonCol>
                <IonCol style={{ textAlign: "center" }}>Quantity</IonCol>
                <IonCol style={{ textAlign: "center" }}>Unit price</IonCol>
                <IonCol style={{ textAlign: "center" }}>Amount </IonCol>
                {Config.gst.enabled && (<>
                    <IonCol style={{ textAlign: "center" }}>GST Rate </IonCol>
                    <IonCol style={{ textAlign: "center" }}>GST Amt </IonCol>
                    <IonCol style={{ textAlign: "center" }}>Total </IonCol>
                </>
                )}
                <IonCol style={{ textAlign: "center" }}>Remove </IonCol>
            </IonItem>
            {Products && Products.map(((item, i) => {
                return (
                    <IonItem key={item.id}>
                        <IonCol style={{ textAlign: "center" }}>{i + 1}</IonCol>

                        <IonCol style={{ textAlign: "center" }}>{item.name}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{item.quantity}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{parseFloat(item.price).toFixed(2)}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{parseFloat(item.amount).toFixed(2)}</IonCol>

                        {Config.gst.enabled && (<>
                            <IonCol style={{ textAlign: "center" }}>{item.gstr}</IonCol>
                            <IonCol style={{ textAlign: "center" }}>{parseFloat(item.gstAmt).toFixed(2)}</IonCol>
                            <IonCol style={{ textAlign: "center" }}>{parseFloat(item.total).toFixed(2)}</IonCol>
                        </>)}

                        <IonCol style={{ textAlign: "center" }}><IonIcon icon={trash} style={{ cursor: 'pointer' }} onClick={() => removeProduct(item.id, item.name, item.quantity)}></IonIcon></IonCol>
                    </IonItem>
                )


            }))}
        </IonList>
    )

    const customers = CustomerList.length ? (
        CustomerList.map((p) => {
            // console.log(p);
            return (
                <option key={p} value={p}></option>
            )
        })
    ) : (null)


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Create Invoice</IonTitle>
                    <IonButtons slot="end">
                        <IonToggle checked={invoiceManual} onIonChange={(e) => {
                            setInvoiceManual(e.detail.checked);
                            setConfig({ ...Config, invoiceManual: e.detail.checked });

                            if (e.detail.checked) {
                                alertController.create({
                                    header: 'Invoice Number Manual Change',
                                    message: 'Do you want to change invoice number manually?',
                                    buttons: [
                                        {
                                            text: 'Cancel',
                                            role: 'cancel',

                                            handler: (blah) => {
                                                setConfig({ ...Config, invoiceManual: false });
                                                setInvoiceManual(false);
                                            }
                                        }, {
                                            text: 'Okay',
                                            role: 'okay',

                                            handler: (blah) => {
                                                console.log(blah);
                                                setInvoiceManual(true);
                                                setConfig({ ...Config, invoiceManual: true });
                                            }
                                        }
                                    ]
                                }).then(alert => {
                                    alert.present();
                                })
                            }
                        }} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>

                <IonRow>
                    <IonCol sizeMd='3'>
                        <IonItem>
                            <IonLabel position='floating'>Customer Name</IonLabel>
                            <IonInput type='text' id="customerName" debounce={1000} autoCapitalize='word' autocomplete='on' placeholder='Name' name='' value={CustomerName} onIonInput={(e) => {
                                setCustomerName((e.target.value).trim())
                                db.ledger.get({ customerName: (e.target.value).trim() }).then((party) => {
                                    if (party) {
                                        setCustomerContact(party.customerContact)
                                        setCustomerDetails(party.customerDetails)
                                        setCustomerGST(party.customerGST)
                                    }

                                })
                            }}></IonInput>
                            <datalist id='customerList'>
                                {customers}
                            </datalist>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Customer Contact</IonLabel>
                            <IonInput type='tel' id="customerContact" placeholder='+91' value={CustomerContact} onIonInput={(e) => { setCustomerContact(e.target.value) }}></IonInput>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Customer Details</IonLabel>
                            <IonTextarea id="customerDetails" value={CustomerDetails} onIonInput={(e) => { setCustomerDetails(e.target.value) }} ></IonTextarea>
                        </IonItem>

                        {
                            Config.gst.enabled ? (
                                <IonItem>
                                    <IonLabel position='floating'>Customer GST</IonLabel>
                                    <IonInput type='text' id="customerGST" pattern={gstPattern} value={CustomerGST} onIonInput={(e) => { setCustomerGST(e.target.value) }}></IonInput>
                                </IonItem>
                            ) : ('')
                        }

                    </IonCol>

                    <IonCol sizeMd='3' offsetMd='5'>

                        {
                            Config.gst.enabled ? (
                                <IonItem>
                                    <IonLabel position='floating'>Sale Type</IonLabel>
                                    <IonSelect value={saletype} interface='popover' onIonChange={e => setSaletype(e.detail.value)}>
                                        <IonSelectOption value="intrastate">Intra-State</IonSelectOption>
                                        <IonSelectOption value="interstate">Inter-State</IonSelectOption>
                                    </IonSelect>
                                </IonItem>
                            ) : ('')
                        }

                        <IonItem>
                            <IonLabel position='stacked'>Date</IonLabel>
                            <input type='date' id="date" value={moment(date).format('YYYY-MM-DD')} onChange={(e) => { setDate(e.target.value) }}></input>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Invoice No. {Config.gst.enabled && '(GST)'}</IonLabel>
                            <IonInput disabled={!invoiceManual} type='number' value={Config.gst.enabled ? gstinvoiceNo : invoiceNo} onIonInput={(e) => { setinvoiceNo(parseInt(e.target.value)) }} id="invoiceNo" ></IonInput>
                        </IonItem>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol sizeMd='3'>
                        {
                            Config.gst.enabled ? (
                                <h6 id='total'>SubTotal : {subTotal.toFixed(2)}</h6>
                            ) : (
                                <h4 id='total'>Total : Rs. {total.toFixed(2)}</h4>
                            )
                        }
                    </IonCol>
                    <IonCol sizeMd='3' offsetMd='5' >{
                        Config.gst.enabled && (
                            <h5 id='total'>Total : {total.toFixed(2)}</h5>
                        )
                    }</IonCol>
                </IonRow>

                {ProductTable}
                <IonItemDivider />
                <IonRow>
                    <IonCol sizeMd='8'>
                        <AddProduct addProduct={addProduct} />
                    </IonCol>
                    <IonCol sizeMd='3'>
                        <IonItem>
                            <IonLabel position='floating'>Amt Paid</IonLabel>
                            <IonInput type='number' placeholder='Amount Paid ' value={AmtPaid} id="amtPaid" onIonInput={(e) => { setAmtPaid(parseFloat(e.target.value)) }}></IonInput>
                        </IonItem>
                        <IonButton color='success' shape='round' type='submit' onClick={generateBill}>Generate Invoice</IonButton>
                    </IonCol>
                </IonRow>

                <iframe className='ion-hide' id='print' title='Print Invoice'></iframe>
            </IonContent>
        </IonPage>
    )
}

export default CreateInvoice
